import { Button, Icon } from '@vechaiui/react';
import { PencilIcon } from '@heroicons/react/outline';
import { createColumnHelper } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';
import { useLocalization } from '@fluent/react';
import { useQuery } from '@apollo/client';
import { useRef } from 'react';

import AppContainerLayout from '#/layouts/AppContainerLayout';
import DataTable from '#/components/display/DataTable';
import { AdminRoute } from '#/constants/page-route';
import { FilterProps } from '#/components/panels/UserFilterPanel';
import { GetUsersDocument, User } from '#/__generated__/graphql/graphql';
import { useInfiniteList } from '#/hooks/use-infinite-list';

const AdminUserListPage = () => {
  const { l10n } = useLocalization();
  const { data, fetchMore, loading } = useQuery(GetUsersDocument);
  const navigate = useNavigate();
  const rootRef = useRef<HTMLDivElement>(null);
  const elementRef = useRef<HTMLDivElement>(null);

  const filterList: FilterProps[] = [
    { count: 2, label: l10n.getString('all') },
    { count: 2, label: l10n.getString('admin') },
    { count: 2, label: l10n.getString('editor') },
    { count: 2, label: l10n.getString('driver') },
  ];

  const handleEdit = (user: User) => {
    // TODO - Handle Edit User
  };

  const columnHelper = createColumnHelper<User>();

  const columns = [
    columnHelper.accessor('username', {
      header: () => renderCellHeader('accounts'),
      cell: (info) => renderCellBody(info.getValue()),
    }),
    columnHelper.accessor('email', {
      header: () => renderCellHeader('email'),
      cell: (info) => renderCellBody(info.getValue()),
    }),
    // columnHelper.accessor('email', {
    //   header: () => renderCellHeader('email'),
    //   cell: (info) => renderCellBody(info.getValue()),
    // }),
    // columnHelper.accessor('role', {
    //   header: () => renderCellHeader('role'),
    //   cell: (info) => renderCellBody(info.getValue()),
    // }),
    // columnHelper.accessor('lastSeen', {
    //   header: () => renderCellHeader('last-seen'),
    //   cell: (info) => renderCellBody(info.getValue()),
    // }),
    // columnHelper.accessor('status', {
    //   header: () => renderCellHeader('status'),
    //   cell: (info) => (
    //     <UserStatusIndicator color={getColorByStatus(info.getValue())} text={info.getValue()} />
    //   ),
    // }),
    // columnHelper.accessor('edit', {
    //   header: () => renderCellHeader('edit'),
    //   cell: (info) => renderCellEdit(info.row.original),
    // }),
  ];

  const renderCellHeader = (label: string) => {
    return (
      <div className="text-left m-3 pb-5 uppercase text-neutral-400">{l10n.getString(label)}</div>
    );
  };

  const renderCellBody = (label: string) => {
    return <div className="text-left m-3 text-black hover:cursor-pointer py-3">{label}</div>;
  };

  const renderCellEdit = (user: User) => {
    return (
      <div
        className="m-3"
        onClick={() => {
          handleEdit(user);
        }}
      >
        <Icon as={PencilIcon} label="check" className="w-5 h-5 text-primary-500" />
      </div>
    );
  };

  useInfiniteList(elementRef, rootRef, () => {
    if (!loading && data?.users?.pageInfo.hasNextPage) {
      fetchMore({ variables: { cursor: data?.users?.pageInfo?.endCursor } });
    }
  });

  return (
    <AppContainerLayout ref={rootRef}>
      <div className="w-full">
        <h1 className="mb-4">{l10n.getString('users')}</h1>
        <div className="flex-col bg-white p-8 rounded-lg space-y-6">
          <div className="flex justify-between">
            <div>
              <h5 className="text-black">{l10n.getString('accounts')}</h5>
              <div className=" text-gray-400">{l10n.getString('admin-page-subheader')}</div>
            </div>
            <Button
              className="w-48 h-12"
              color="primary"
              onClick={() => navigate(AdminRoute.UserNew)}
              size="lg"
              type="button"
              variant="solid"
            >
              {l10n.getString('add-new-user')}
            </Button>
          </div>

          {/* TODO :: Issue 333 */}
          {/* <div className="flex">
            <Input.Group>
              <Input.LeftElement
                className=""
                children={
                  <Icon
                    as={SearchIcon}
                    label="search"
                    className="justify-items-center w-5 h-5 text-gray-300"
                  />
                }
              />
              <Input className="h-11 mr-10 w-96" placeholder={'Search name, email or username'} />
            </Input.Group>
            <UserFilterPanel filterList={filterList} />
          </div> */}

          <div>
            {!!data?.users?.edges && data.users.edges.length > 0 ? (
              <DataTable
                data={data.users.edges.map(({ node }) => node)}
                columns={columns}
                className={'w-full text-black'}
                onClick={(value: any) => {
                  navigate(generatePath(AdminRoute.UserDetails, { userId: value.id }));
                }}
              />
            ) : (
              <div>No record found</div>
            )}

            <div ref={elementRef} />
          </div>
        </div>
      </div>
    </AppContainerLayout>
  );
};

export default AdminUserListPage;
